import React from "react"


const NotFound = () => {

    return <main>
            <p>404 NOT FOUND<br />La page que vous cherchez n'est pas disponible</p>
    </main>
}
export default NotFound